import { useAuth } from '@BUP/hooks';
import { checkComponentPermissions } from '@BUP/rbac';

const RBAC = ({ children, name }) => {
  const { user } = useAuth();
  const userRole = user.roles.type;
  const isAllowed = checkComponentPermissions(userRole, name);
  return isAllowed && children;
};

export default RBAC;
